import cn from "classnames";
import { useEffect, useMemo, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { NUM_BOARDS, NUM_GUESSES, WORDS_VALID, WORDS_VALID_5 } from "../consts";
import { getGuessColors, range } from "../funcs";
import { useSelector, setCurrentState } from "../store";

const wordsGroup: any = {}
WORDS_VALID.forEach((word) => {
  wordsGroup[word.length] = wordsGroup[word.length] || [];
  wordsGroup[word.length].push(word);
})
wordsGroup[5] = WORDS_VALID_5;

export default function GameBoard({ type = 'sedecordle' }) {
  const [searchParams] = useSearchParams()
  const length: number = Number(searchParams.get('length') || 5)
  const [fontSize, setFontSize] = useState<number>(30);
  const boardRef = useRef<any>(null);

  useEffect(() => {
    if (boardRef.current) {
      setFontSize(boardRef.current.offsetWidth / length * 0.35);
    }
  }, [length])

  const test: any = useSelector((s) => s.game.targets);
  localStorage.setItem(`answer-${type}`, test);
  const answers:any = localStorage.getItem(`answer-${type}`)?.split(',')
  const seq = answers.shift()

  //console.log(target.targets)
  return (
    <div
      className="boards bg-custom dark:bg-custom text-white dark:text-white"
      ref={boardRef}
      style={{ fontSize: `${fontSize}px` }}
    >
      {range(NUM_BOARDS).map((i) => (
        <div key={i} id={cn(i === 0 ? '0' : i)}>
          <Board key={i} idx={i} seq={seq} wordsValid={wordsGroup[length]} type={type} />
        </div>
      ))}
    </div>
  );
}


type BoardProps = {
  idx: number;
  seq: any;
  wordsValid: any;
  type: string;
};
function Board(props: BoardProps) {
  // console.log(props.seq)
  const dispatch = useDispatch();

  const [searchParams] = useSearchParams();
  const length: number = Number(searchParams.get('length') || 5);

  const target = useSelector((s) => s.game.targets[props.idx]);
  // const target = props.seq;
  const guesses = useSelector((s) => s.game.guesses);
  const colors = useMemo(
    () => guesses.map((guess) => getGuessColors(guess, target, length)),
    [guesses, target, length]
  );
  const guessed: any = useMemo(() => {
    const idx = guesses.indexOf(target);
    return idx === -1 ? null : idx ;
  }, [guesses, target]);

  const boardWon = useMemo(
    () => guesses.indexOf(target) !== -1,
    [target, guesses]
  );
  const first: any = localStorage.getItem(`answer-${props.type}`)?.split(',');
  const gameOver = useSelector((s) => s.game.gameOver);
  var complete = boardWon && !gameOver;

  const input = useSelector((s) => s.game.input);
  const currentState = useSelector((s) => s.game.currentState)

  if(props.idx - 1  > currentState && complete && props.type === 'sedec-order'){
    complete = false
  }

  if (complete && first && first[0] === props.seq) {
    first.shift()
    localStorage.setItem(`answer-${props.type}`, first)
  }

  if (complete && props.idx - 1 === currentState) {
    dispatch(setCurrentState({ currentState: props.idx }))
  }

  return (
    <div className={cn("board", complete && "complete")} style={{gridTemplateColumns: `repeat(${length},1fr)`}}>
      {range(NUM_GUESSES).map((i, index) => {
        if (props.idx - 1 > currentState && props.type === 'sedec-order') {
          return <Word key={index} letters={guesses[i] ?? ""}  />;
        } else {
          if (guessed !== null && i > guessed) {
            return <Word key={index} letters="" />;
          } else if (i === guesses.length) {
            const textRed = input.length === length && props.wordsValid.indexOf(input.toLowerCase()) === -1;
            return <Word key={index} letters={input} textRed={textRed} />;
          } else {
            return <Word key={index} letters={guesses[i] ?? ""} colors={colors[i]} />;
          }
        }
      })}
    </div>
  );
}

type WordProps = {
  letters: string;
  colors?: string;
  textRed?: boolean;
};
function Word(props: WordProps) {
  const [searchParams] = useSearchParams()
  const length: number = Number(searchParams.get('length') || 5)
  return (
    <>
      {range(length).map((i) => (
        <Cell
          key={i}
          letter={props.letters[i] ?? ""}
          textRed={props.textRed}
          color={props.colors ? (props.colors[i] as "B") : undefined}
        />
      ))}
    </>
  );
};

type CellProps = {
  letter: string;
  textRed?: boolean;
  color?: "B" | "Y" | "G";
};
function Cell(props: CellProps) {
  const color =
    props.color === "Y" ? "yellow" : props.color === "G" ? "green" : 'dark:bg-custom';
  const textRed = props.textRed ? "text-red" : "";
  return (
    <div
      className={cn("cell border-solid dark:border-solid border-white dark:border-white", color, textRed)}
    >
      <span className="letter">{props.letter}</span>
    </div>
  );
}
